<template>
  <div class="sidebar-nav sidebar--nav">
    <div class="sidebar-nav-body">
      <div class="side-menu-close">
        <i class="la la-times"></i>
      </div><!-- end menu-toggler -->
      <div class="author-content">
        <div class="d-flex align-items-center">
          <div class="author-img avatar-sm d-flex">
<!--            Todo: Replace with generic bucket-->
            <img :src="cruiseBrandLogo" alt="logo" class="logo"
                 style="width: auto;height: 80px;margin: auto;">
          </div>
          <div class="author-bio">
<!--            <h4 class="author__title">{{ user }}</h4>-->
            <span class="author__meta">Panele Hoş Geldiniz</span>
          </div>
        </div>
      </div>
      <div class="sidebar-menu-wrap">
        <ul class="sidebar-menu toggle-menu list-items">
<!--          <li v-bind:class="[activeTab === 'reports' ? 'page-active' : '']">-->
          <li v-bind:class="[activeTab === 'sail' ? 'page-active' : '']" v-if="panelRights['PANEL_ASIDE_MENU_SAILS']">
            <a :href="basePath+'/sails'"><i class="la la-train mr-2 text-color-3">
            </i>Seferler</a></li>
          <li v-bind:class="[activeTab === 'booking' ? 'page-active' : '']" v-if="panelRights['PANEL_ASIDE_MENU_BOOKING']">
            <span class="side-menu-icon toggle-menu-icon">
                <i class="la la-angle-down"></i>
            </span>
            <a :href="basePath+'/bookings'"><i class="la la-address-book mr-2 text-color-7"></i>Rezervasyon</a>
            <ul class="toggle-drop-menu">
              <li v-if="panelRights['PANEL_ASIDE_MENU_BOOKING_BOOKINGS_FILTER']"><a :href="basePath+'/bookings?status=OK'"><i class="la la-address-book mr-2 text-color-7"></i>Başarılı</a></li>
              <li v-if="panelRights['PANEL_ASIDE_MENU_BOOKING_BOOKINGS_FILTER']"><a :href="basePath+'/bookings?status=PARTIALLY_PAID'"><i class="la la-address-book mr-2 text-color-7"></i>Parçalı Ödeme</a></li>
              <li v-if="panelRights['PANEL_ASIDE_MENU_BOOKING_BOOKINGS_FILTER']"><a :href="basePath+'/bookings?status=CANCELLED'"><i class="la la-address-book mr-2 text-color-7"></i>İptal</a></li>
              <li v-if="panelRights['PANEL_ASIDE_MENU_BOOKING_BOOKINGS_FILTER']"><a :href="basePath+'/bookings?status=PENDING'"><i class="la la-address-book mr-2 text-color-7"></i>Beklemede</a></li>
              <li v-if="panelRights['PANEL_ASIDE_MENU_BOOKING_BOOKINGS_FILTER_COMPLIMENTARY']"><a :href="basePath+'/bookings?status=COMPLIMENTARY'"><i class="la la-address-book mr-2 text-color-7"></i>Ücretsiz</a></li>
<!--              <li v-if="panelRights['PANEL_ASIDE_MENU_BOOKING_CONFIRMATION']"><a :href="basePath+'/bookings/confirmation'"><i class="la la-address-book mr-2 text-color-7"></i>Onay Durumu</a></li>-->
              <li v-if="panelRights['PANEL_ASIDE_MENU_BOOKING_HISTORY']"><a :href="basePath+'/bookings/archived'"><i class="la la-address-book mr-2 text-color-7"></i>Geçmiş Rezervasyonlar</a></li>
              <li v-if="panelRights['PANEL_ASIDE_MENU_GROUP_RESERVATION']"><a :href="basePath+'/group-reservation'"><i class="la la-address-book mr-2 text-color-7"></i>Group Rezervasyonu</a></li>
            </ul>
          </li>

          <li v-if="panelRights['PANEL_ASIDE_MENU_PRICINGS']" v-bind:class="[activeTab === 'price' || activeTab === 'additional-price' ? 'page-active' : '', activeTab === 'market' ? 'active' : '']">
            <span class="side-menu-icon toggle-menu-icon">
                <i class="la la-angle-down"></i>
            </span>
            <a :href="basePath+'/pricings'"><i class="la la-money mr-2"></i>Fiyatlandırmalar</a>
            <ul class="toggle-drop-menu" :style="activeTab === 'price' || activeTab === 'market' || activeTab === 'additional-price' ? 'display: block;':''">
              <li v-if="panelRights['PANEL_ASIDE_MENU_PRICINGS_PRICING']" v-bind:class="[activeTab === 'price' ? 'page-active' : '']">
                <a :href="basePath+'/pricings'"><i class="la la-money mr-2 text-color-4">
                </i>Fiyatlandırma</a></li>
              <li v-if="panelRights['PANEL_ASIDE_MENU_PRICINGS_ADDITIONAL_SERVICE_PRICING']" v-bind:class="[activeTab === 'additional-price' ? 'page-active' : '']">
                <a :href="basePath+'/additional-service/pricings'"><i class="la la-money mr-2 text-color-4">
                </i>Ek Hizmet Fiyatlandırma</a></li>
              <li v-if="panelRights['PANEL_ASIDE_MENU_PRICINGS_MARKETS']" v-bind:class="[activeTab === 'market' ? 'page-active' : '']">
                <a :href="basePath+'/markets'"><i class="la la-globe mr-2 text-color-3">
                </i>Market</a></li>
            </ul>
          </li>

<!--          <li v-bind:class="[activeTab === 'agency' ? 'page-active' : '']">-->
<!--            <a :href="basePath+'/agencies'"><i class="la la-user-tie mr-2 text-color-5">-->
<!--            </i>Acenteler</a>-->
<!--          </li>-->

          <li v-if="panelRights['PANEL_ASIDE_MENU_AGENCY']" v-bind:class="[activeTab === 'agency-outline' ? 'page-active active' : '',
                             activeTab === 'agency-proforma' ? 'page-active' : '',
                             activeTab === 'agency' ? 'page-active active':'']">
            <span class="side-menu-icon toggle-menu-icon">
                <i class="la la-angle-down"></i>
            </span>
            <a :href="basePath+'/agencies'"><i class="la la-book mr-2"></i>Acente</a>
            <ul class="toggle-drop-menu" :style="activeTab === 'agency' ||
                                                 activeTab === 'agency-proforma' ||
                                                 activeTab === 'agency-outline'
                                                                      ? 'display: block;':''">
              <li v-if="panelRights['PANEL_ASIDE_MENU_AGENCY_AGENCIES']" v-bind:class="[activeTab === 'agency' ? 'page-active' : '']">
                <a :href="basePath+'/agencies'"><i class="la la-route mr-2 text-color-3">
                </i>Acenteler</a></li>

              <li v-if="panelRights['PANEL_ASIDE_MENU_AGENCY_OUTLINE'] && projectName === 'selectum'" v-bind:class="[activeTab === 'agency-outline' ? 'page-active' : '']">
                <a :href="basePath+'/agency/outline'"><i class="la la-anchor mr-2 text-color-3">
                </i>Acente Muhasebe</a></li>
              <li v-if="panelRights['PANEL_ASIDE_MENU_AGENCY_PROFORMA'] && projectName === 'miray'" v-bind:class="[activeTab === 'agency-proforma' ? 'page-active' : '']">
                <a :href="basePath+'/agency/proforma'"><i class="la la-anchor mr-2 text-color-3">
                </i>Proforma</a></li>
              <li v-if="panelRights['PANEL_ASIDE_MENU_AGENCY_PROFORMA'] && projectName === 'miray'" v-bind:class="[activeTab === 'agency-proforma' ? 'page-active' : '']">
                <a :href="basePath+'/proforma-invoices'"><i class="la la-anchor mr-2 text-color-3">
                </i>Proforma/Fatura</a></li>
            </ul>
          </li>

          <li v-if="panelRights['PANEL_ASIDE_MENU_DEFINITIONS']" v-bind:class="[activeTab === 'seaTour' ? 'page-active' : '',
                             activeTab === 'port' ? 'active':'',
                             activeTab === 'cruise' ? 'active':'',
                             activeTab === 'country' ? 'active':'',
                             activeTab === 'city' ? 'active':'',
                             activeTab === 'district' ? 'active':'',
                             ]">
            <span class="side-menu-icon toggle-menu-icon">
                <i class="la la-angle-down"></i>
            </span>
            <a :href="basePath+'/seatours'"><i class="la la-book mr-2"></i>Tanımlamalar</a>
            <ul class="toggle-drop-menu" :style="activeTab === 'seaTour' || activeTab === 'port' || activeTab === 'cruise' ||
                                                 activeTab === 'country' || activeTab === 'city' || activeTab === 'district' ? 'display: block;':''">
              <li v-if="panelRights['PANEL_ASIDE_MENU_DEFINITIONS_SEATOURS']" v-bind:class="[activeTab === 'seaTour' ? 'page-active' : '']">
                <a :href="basePath+'/seatours'"><i class="la la-route mr-2 text-color-3">
                </i>Tur</a></li>
              <li v-if="panelRights['PANEL_ASIDE_MENU_DEFINITIONS_PORTS']" v-bind:class="[activeTab === 'port' ? 'page-active' : '']">
                <a :href="basePath+'/ports'"><i class="la la-anchor mr-2 text-color-3">
                </i>Liman</a></li>
              <li v-if="panelRights['PANEL_ASIDE_MENU_DEFINITIONS_CRUISES']" v-bind:class="[activeTab === 'cruise' ? 'page-active' : '']" >
                <a :href="basePath+'/cruises'"><i class="las la-ship mr-2 text-color-3">
                </i>Cruises</a></li>
              <li v-if="panelRights['PANEL_ASIDE_MENU_DEFINITIONS_COUNTRIES']" v-bind:class="[activeTab === 'country' ? 'page-active' : '']">
                <a :href="basePath+'/countries'"><i class="la la-globe mr-2 text-color-3">
                </i>Ülkeler</a></li>
              <li v-if="panelRights['PANEL_ASIDE_MENU_DEFINITIONS_CITIES']" v-bind:class="[activeTab === 'cities' ? 'page-active' : '']">
                <a :href="basePath+'/cities'"><i class="la la-globe mr-2 text-color-3">
                </i>Şehirler</a></li>
              <li v-if="panelRights['PANEL_ASIDE_MENU_DEFINITIONS_DISTRICTS']" v-bind:class="[activeTab === 'district' ? 'page-active' : '']">
                <a :href="basePath+'/districts'"><i class="la la-globe mr-2 text-color-3">
                </i>İlçeler</a></li>
            </ul>
          </li>


<!--          <li v-bind:class="[activeTab === 'dashboard' ? 'page-active' : '']" >-->
<!--            <a :href="basePath+'/reports/1'"><i class="la la-chart-line mr-2">-->
<!--            </i>Dashboard</a></li>-->


<!--          <li v-bind:class="[activeTab === 'payment' ? 'page-active' : '']">-->
<!--&lt;!&ndash;            <span class="side-menu-icon toggle-menu-icon">&ndash;&gt;-->
<!--&lt;!&ndash;                <i class="la la-angle-down"></i>&ndash;&gt;-->
<!--&lt;!&ndash;            </span>&ndash;&gt;-->
<!--            <a :href="basePath+'/payments'"><i class="la la-star mr-2 text-color-5">-->
<!--            </i>Ödeme</a>-->
<!--&lt;!&ndash;            <ul class="toggle-drop-menu">&ndash;&gt;-->
<!--&lt;!&ndash;              <li><a :href="basePath+'/coupons'"><i class="la la-paypal mr-2"></i>Kupon</a></li>&ndash;&gt;-->
<!--&lt;!&ndash;            </ul>&ndash;&gt;-->
<!--          </li>-->
<!--          <li v-bind:class="[activeTab === 'coupon' ? 'page-active' : '']">-->
<!--            <a :href="basePath+'/coupons'"><i class="la la-star mr-2 text-color-5">-->
<!--            </i>Kupon</a></li>-->

<!--          <li v-bind:class="[activeTab === 'booking/assistance' ? 'page-active' : '']">-->
<!--            <a :href="basePath+'/booking-assistance'"><i class="la la-codepen mr-2 text-color-7"></i>İletişim Formu</a></li>-->

<!--          <li v-bind:class="[activeTab === 'content' ? 'page-active' : '']"><a href="javascript:void(0)"><i class="la la-cog mr-2 text-color-10"></i>İçerik</a></li>-->
<!--          <li v-bind:class="[activeTab === 'userManagement' ? 'page-active' : '']"><a href="javascript:void(0)"><i class="la la-user mr-2 text-color-11"></i>Kullanıcı Yönetimi</a></li>-->
<!--          <li v-bind:class="[activeTab === 'settings' ? 'page-active' : '']"><a href="javascript:void(0)"><i class="la la-at mr-2 text-color-11"></i>Ayarlar</a></li>-->

          <li v-if="panelRights['PANEL_ASIDE_MENU_REPORTS']" v-bind:class="[activeTab === 'reports' ? 'page-active' : '']">
            <span class="side-menu-icon toggle-menu-icon">
                <i class="la la-angle-down"></i>
            </span>
            <a :href="basePath+'/reports/1'"><i class="la la-chart-pie mr-2"></i>Raporlar</a>
            <ul class="toggle-drop-menu">
              <li v-if="panelRights['PANEL_ASIDE_MENU_REPORTS_DASHBOARD']"><a :href="basePath+'/reports/1'"><i class="la la-chart-line mr-2 text-color-7"></i>Dashboard</a></li>
              <li v-if="panelRights['PANEL_ASIDE_MENU_REPORTS_FORECAST']"><a :href="basePath+'/forecast'"><i class="la la-chart-line mr-2 text-color-7"></i>Sefer Oda Raporu</a></li>
              <li v-if="panelRights['PANEL_ASIDE_MENU_REPORTS_FORECAST_REPORT']"><a :href="basePath+'/reports/161'"><i class="la la-chart-line mr-2 text-color-7"></i>Forecast Raporu</a></li>
              <li v-if="projectName === 'miray'"><a :href="basePath+'/reports/98'"><i class="la la-chart-line mr-2 text-color-7"></i>Acenteler</a></li>
              <li v-if="projectName === 'miray' && panelRights['PANEL_ASIDE_MENU_REPORTS_RESERVATION_REPORT']"><a :href="basePath+'/reports/2'"><i class="la la-chart-line mr-2 text-color-7"></i>Rezervasyon Raporu</a></li>
              <li v-if="projectName === 'selectum' && panelRights['PANEL_ASIDE_MENU_REPORTS_RESERVATION_REPORT']"><a :href="basePath+'/reports/3'"><i class="la la-chart-line mr-2 text-color-7"></i>Rezervasyon Raporu</a></li>
              <li v-if="projectName === 'selectum' && panelRights['PANEL_ASIDE_MENU_REPORTS_ROOM_AVAILABILITY']"><a :href="basePath+'/reports/4'"><i class="la la-chart-line mr-2 text-color-7"></i>Oda Musaitlik</a></li>
              <li v-if="projectName === 'selectum' && panelRights['PANEL_ASIDE_MENU_REPORTS_AGENCY_PAYMENTS']"><a :href="basePath+'/reports/97'"><i class="la la-chart-line mr-2 text-color-7"></i>Acente Ödemeler</a></li>
              <li v-if="panelRights['PANEL_ASIDE_MENU_REPORTS_SAIL_RESERVATION_REPORT']"><a :href="basePath+'/sefer-rezervasyon-raporu'"><i class="la la-chart-line mr-2 text-color-7"></i>Sefer Rezervasyon Raporu</a></li>
              <li v-if="panelRights['PANEL_ASIDE_MENU_REPORTS_AGENCY_RESERVATION_REPORT'] && projectName === 'miray'"><a :href="basePath+'/acente-rezervasyon-raporu'"><i class="la la-chart-line mr-2 text-color-7"></i>Acente Rezervasyon Raporu</a></li>
              <li v-if="panelRights['PANEL_PAGE_BOOKING_AGENCY_COMMISSION_RATE_REPORT'] && projectName === 'miray'"><a :href="basePath+'/reports/130'"><i class="la la-chart-line mr-2 text-color-7"></i>Acente Rezervasyon Komisyon Raporu ( Yeni )</a></li>
              <li v-if="panelRights['PANEL_PAGE_BOOKING_AGENCY_COMMISSION_RATE_REPORT']"><a :href="basePath+'/booking-agency-commission-report'"><i class="la la-chart-line mr-2 text-color-7"></i>Acente Rezervasyon Komisyon Raporu</a></li>
              <li v-if="projectName === 'miray'"><a :href="basePath+'/reports/66'"><i class="la la-chart-line mr-2 text-color-7"></i>Acente Kullanıcı Raporu</a></li>
              <li v-if="projectName === 'selectum' && panelRights['PANEL_ASIDE_MENU_REPORTS_AGENCY_PAYMENTS']"><a :href="basePath+'/reports/193'"><i class="la la-chart-line mr-2 text-color-7"></i>Moka Logları</a></li>
              <!--              <li><a :href="basePath+'/booking?status=PARTIALLY_PAID'"><i class="la la-address-book mr-2 text-color-7"></i>Parçalı Ödeme</a></li>-->
              <!--              <li><a :href="basePath+'/booking?status=CANCELLED'"><i class="la la-address-book mr-2 text-color-7"></i>İptal</a></li>-->
              <!--              <li><a :href="basePath+'/booking?status=PENDING'"><i class="la la-address-book mr-2 text-color-7"></i>Beklemede</a></li>-->
            </ul>
          </li>
          <li v-if="panelRights['PANEL_ASIDE_MENU_MANAGEMENT']" v-bind:class="[activeTab === 'reports' ? 'page-active' : '']">
            <span class="side-menu-icon toggle-menu-icon">
                <i class="la la-angle-down"></i>
            </span>
            <a :href="basePath+'/roles'"><i class="la la-chart-pie mr-2"></i>Yönetim</a>
            <ul class="toggle-drop-menu">
              <li v-if="panelRights['PANEL_ASIDE_MENU_MANAGEMENT_ROLES']" ><a :href="basePath+'/roles'"><i class="la la-chart-line mr-2 text-color-7"></i>Role Yetkilendirme</a></li>
              <li v-if="panelRights['PANEL_ASIDE_MENU_MANAGEMENT_ACCESS_LOGS']" ><a :href="basePath+'/access-logs'"><i class="la la-chart-line mr-2 text-color-7"></i>Erişim Logları</a></li>
            </ul>
          </li>
          <li v-if="panelRights['PANEL_ASIDE_MENU_SETTINGS']" v-bind:class="[activeTab === 'settings' ? 'page-active' : '']"><a :href="basePath+'/settings'"><i class="la la-gear mr-2 text-color-11"></i>Ayarlar</a></li>
          <li v-bind:class="[activeTab === 'logout' ? 'page-active' : '']"><a @click="logout()" href="#"><i class="la la-power-off mr-2 text-color-11"></i>Çıkış</a></li>
        </ul>
      </div><!-- end sidebar-menu-wrap -->
    </div>
  </div>
</template>

<script>
export default {
  name: "myAsidebar",
  props : {
    "activeTab": String
  },
  computed:{
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    },
    cruiseBrandLogo:{
      get(){
        return this.$store.getters.getCdnPath + "/vendor/images/logo.png";
      }
    },
    filterStatus:{
      get() {
        let params = (new URL(document.location)).searchParams;
        return params.get("status");
      }
    },
    projectName:{
      get() {
        return this.$store.getters.getProjectName;
      }
    },
    panelRights:{
      get(){
        return this.$store.getters.getPanelRightsMap;
      }
    }
  },
  methods:{
    logout(){
      this.$store.dispatch("logout");
      window.location.reload();
    },
  }
}
</script>

<style scoped>

</style>